<template>
  <el-card style="height: 820px;overflow-y: scroll;">
    <el-tabs v-model="tabActive" @tab-click="tabHandle">
      <el-tab-pane label="数据统计" name="first">
          <Data_statistics></Data_statistics>
      </el-tab-pane>

      <el-tab-pane label="数据检索" name="second" style="width: 100%;height: 700px;">
        <keep-alive>
          <Data_search></Data_search>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import Data_statistics from "@/components/data_statistics";
import Data_search from "@/components/data_search";

export default {
  name: "StaticView",
  components: {Data_search, Data_statistics},
  data() {
    return {
      tabActive: 'first',
    }
  },
  mounted() {
  },
  methods: {
    tabHandle(tab, event) {
      console.log(tab, event);
    }
  },
}
</script>

<style scoped>
:deep(.el-cascader) {
  width: 400px !important;
}

.el-card {
  width: 99%;
}
</style>